/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  HeaderService,
  IHeaderMethods,
  SettingsService,
  ISettingsMethods,
  IPolicyListsMethods,
  PolicyListsService,
  LoadingService,
  ILoadingMethods,
  IStaticPageContentMethods,
  StaticPageContentService,
  FooterService,
  IFooterMethods,
  IDownloadPolicyListsMethods,
  DownloadPolicyListsService
} from "./components";

export type ActualPageAgent = IHeaderMethods &
  ISettingsMethods &
  IPolicyListsMethods &
  IStaticPageContentMethods &
  ILoadingMethods &
  IFooterMethods &
  IDownloadPolicyListsMethods;

const getPlugins = () => {
  return [
    new HeaderService(),
    new SettingsService(),
    new PolicyListsService(),
    new LoadingService(),
    new StaticPageContentService(),
    new FooterService(),
    new DownloadPolicyListsService(),
  ];
};

export const getAgent = () => {
  return createAgent<ActualPageAgent>({
    plugins: getPlugins(),
  });
};
